import React from 'react';
import ComponentHelper from '../../../supers/ComponentHelper';
import ScriptEndpointForm from '../script-endpoint-form/ScriptEndpointForm';
import IntegrationEndpointForm from '../integration-endpoint-form/IntegrationEndpointForm';

class EndpointCreator extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			step: 1,
			type: 'script'
		};
	}

	onNewIntegration = () => {
		this.observe(() => {
			this.data.step = 2;
			this.data.type = 'integration';
		});
	};

	onNewScript = () => {
		this.observe(() => {
			this.data.step = 2;
			this.data.type = 'script';
		});
	};

	componentDidMount() {}

	componentWillUnmount() {}

	render() {
		let { step, type } = this.data;
		return (
			<div className="endpoints-creator-view animated fadeIn">
				{step === 1 && (
					<div className="step-1">
						<div className="step-header">
							<h3>Choose an API endpoint type</h3>
						</div>
						<div className="type-ctn hbox vcenter hcenter">
							<div className="type-box vbox hcenter vcenter shadow hover" onClick={this.onNewIntegration}>
								<i className="mdi mdi-lan-pending" />
								<div className="name">Integration</div>
								<div className="desc">Integration endpoints allow you to call other systems in order to get information to perform operations.</div>
							</div>
							<div className="type-box vbox hcenter vcenter shadow hover" onClick={this.onNewScript}>
								<i className="mdi mdi-json" />
								<div className="name">Script</div>
								<div className="desc">Custom code endpoints allow you to store JavaScript routines with custom code.</div>
							</div>
						</div>
					</div>
				)}
				{step === 2 && type === 'script' && <ScriptEndpointForm className="step-2" />}
				{step === 2 && type === 'integration' && <IntegrationEndpointForm className="step-2" />}
			</div>
		);
	}
}

export default EndpointCreator;



// WEBPACK FOOTER //
// ./src/views/endpoints-panel/endpoint-creator/EndpointCreator.js